"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class Source {
    constructor(instance) {
        this.instance = instance;
    }
    list() {
        return new Promise((resolve, reject) => {
            const URL = '/sources';
            this.instance.get(URL)
                .then((res) => {
                const sources = res.data;
                const sourcesMapped = lodash_1.map(sources, (source) => {
                    const list = {
                        value: source.id,
                        text: source.name,
                    };
                    return list;
                });
                resolve(sourcesMapped);
            })
                .catch((err) => {
                reject({
                    code: 'sources-list-error',
                    message: err.response.data.message,
                });
            });
        });
    }
}
exports.Source = Source;
//# sourceMappingURL=source.js.map